import React from 'react';
import { ChoiceButton, QuestionMark } from 'react-design-components';
import { HelpModal } from 'react-commons';
import { ChoiceWrapper } from '../Elements';
import { HouseHoldHelp } from '../Help';
import useHouseHold from './hooks/useHouseHold';
import { FlowEnum, ComponentsEnum, HouseHoldEnum } from '../../types';
import { MainLayout } from '../MainLayout';
import Greeting from './Greeting';

export interface Props {
  nextUrl: string;
  progress?: number;
  flow?: FlowEnum;
}

const HouseHold: React.FC<Props> = (props: Props) => {
  const { progress, flow } = props;

  const { classes, t, directAccess, onClick, toggleHelpModal } = useHouseHold(props);

  return (
    <MainLayout
      navigationId={ComponentsEnum.HOUSE_HOLD}
      flow={flow}
      progress={progress}
      directAccess={directAccess}
      t={t}
      pageTitle="page_title"
    >
      <HelpModal>
        <HouseHoldHelp />
      </HelpModal>
      <div className={classes.alignBottom}>
        <Greeting>
          <QuestionMark onHelpClick={toggleHelpModal} title={t('question')}>
            <ChoiceWrapper>
              <ChoiceButton onClick={() => onClick(HouseHoldEnum.ONE)} data-testid="household-1">
                <span className={classes.houseHoldTitle}>1</span>
                <span className={classes.houseHoldDescription}>{t('person')}</span>
              </ChoiceButton>

              <ChoiceButton onClick={() => onClick(HouseHoldEnum.TWO)} data-testid="household-2">
                <span className={classes.houseHoldTitle}>2</span>
                <span className={classes.houseHoldDescription}>{t('people')}</span>
              </ChoiceButton>

              <ChoiceButton onClick={() => onClick(HouseHoldEnum.THREE)} data-testid="household-3">
                <span className={classes.houseHoldTitle}>3</span>
                <span className={classes.houseHoldDescription}>{t('people')}</span>
              </ChoiceButton>

              <ChoiceButton onClick={() => onClick(HouseHoldEnum.MORE_THAN_THREE)} data-testid="household-4">
                <div className={classes.houseHoldTitle}>+4</div>
                <div className={classes.houseHoldDescription}>{t('people')}</div>
              </ChoiceButton>
            </ChoiceWrapper>
          </QuestionMark>
        </Greeting>
      </div>
    </MainLayout>
  );
};

export default HouseHold;
